var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home_wrapper"}},[_c('div',{staticClass:"home"},[_c('AppNavigation'),_c('Hero')],1),_c('About'),_c('TheInstitute'),_c('Contact'),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }